const AVATAR_SIZE = 52;
const OPTIONS_SIZE = 50;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - AVATAR_SIZE - OPTIONS_SIZE) * percent;
};

export const getColumns = ({ totalWidth }: { totalWidth?: number }) => [
  {
    accessorKey: 'avatar',
    size: AVATAR_SIZE,
    isAvatar: true,
  },
  {
    accessorKey: 'name',
    minSize: 62,
    sx: { pl: 0 },
    size: getColumnSize(1, totalWidth),
    enableResizing: true,
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
  {
    accessorKey: 'options',
    size: OPTIONS_SIZE,
    isOptions: true,
  },
];
